module.exports = __webpack_public_path__ + "img/projects-shape-2.17aad0c2.png";